import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { usersAPI } from '../../services/api';

export default function Employees() {
  const [employees, setEmployees] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    usersAPI.list({ role: 'employee' }).then(({ data }) => setEmployees(data)).finally(() => setLoading(false));
  }, []);

  const filtered = employees.filter(
    (e) => e.full_name.toLowerCase().includes(search.toLowerCase()) ||
           e.email.toLowerCase().includes(search.toLowerCase()) ||
           (e.department || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="page">
      <div className="page-header">
        <h2>Employees</h2>
      </div>

      <div className="filter-bar">
        <input
          type="search"
          placeholder="Search by name, email or department..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="search-input"
        />
      </div>

      {loading ? <div className="page-loading">Loading...</div> : (
        <div className="card">
          <table className="data-table">
            <thead>
              <tr><th>Name</th><th>Employee ID</th><th>Email</th><th>Department</th><th>Status</th><th>Actions</th></tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr><td colSpan={6} className="text-center text-muted">No employees found</td></tr>
              ) : filtered.map((e) => (
                <tr key={e.id}>
                  <td>
                    <Link to={`/hr/employees/${e.id}`} className="table-link">{e.full_name}</Link>
                  </td>
                  <td>{e.employee_id || '—'}</td>
                  <td>{e.email}</td>
                  <td>{e.department || '—'}</td>
                  <td>
                    <span className={`badge badge-${e.is_active ? 'green' : 'red'}`}>
                      {e.is_active ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td>
                    <Link to={`/hr/employees/${e.id}`} className="btn btn-sm btn-ghost">View</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
